import { render } from "./user-surveys.vue?vue&type=template&id=39d734bf&scoped=true"
import script from "./user-surveys.vue?vue&type=script&lang=js"
export * from "./user-surveys.vue?vue&type=script&lang=js"

import "./user-surveys.vue?vue&type=style&index=0&id=39d734bf&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-39d734bf"

export default script